import React, { Fragment, useRef, useState, useEffect } from 'react'
import { Col, Container, Row, Button } from 'reactstrap'
import { useViewCalender } from '../../hooks/serieB/useViewCalender'
import FullCalendar from "@fullcalendar/react";
import timeGridPlugin from "@fullcalendar/timegrid";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import esLocale from '@fullcalendar/core/locales/es';
import './styleCalender.css';
import "moment/locale/es";
import { ModalEvent } from './ModalEvent';
import "bootstrap-daterangepicker/daterangepicker.css";
import { Modal } from "react-morphing-modal";
import { useModal } from "react-morphing-modal";
import { useHistory } from 'react-router-dom';
import { TabMenu } from 'primereact/tabmenu';
import { Programming } from './Programming';
import { Dialog } from 'primereact/dialog';
import { DetailProgramming } from './DetailProgramming';
import { ProgrammingDeposits } from './ProgrammingDeposits';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';






export const IndexViewCalender = () => {


  const {

    //*CONFIGURATION CALENDER
    weekendsVisible,

    //*VARIABLES AND REF COMPONENTS
    calendarRef, treeViewRef,

    //*VARIABLES GLOBALES CALENDER
    start, end, setEnd, setStart,

    //*VARIABLES CALENDER,
    loadingPreview,

    //*VARIABLES MODAL
    modalTitle, toggleModalEvent, modalPreviewInvoice, handleClose, tolerance,

    //*SAVE METHOD
    loadingSave,

    //*DETAIL VIEW CALENDER
    eventView, loadingViews, ViewsEvents,

    //*DETAIL BRANCH
    listBranchesTree,

    //*CONFIGURATION VIEWS
    dateFilter, setDateFilter, loadingProgramming,

    //* FORM CALENDER
    amount_required, handleInputChange, title, observation,

    //*INPUT DATE AND TREE
    onRenderItem, onChangeItemtree, handleChangeAmount, handleFilterDate,

    //*FUNCTION
    handleSelectDate, handleEvent, handeGeneralEvent, countSelected,

    //*POST AND GET METHODS
    saveProgrammingDiary, GetProgrammingAmount,

    //*VALIDATIONS
    validationsCreate,

    //*DETAIL INFORMATION CALENDER
    detailInformation,

    //*DATA TABLE
    setHoveredColumn, hoveredColumn,

    //*CONFIGURATIONS DETAIL
    handleViewDetails, valid_visible, handleCloseViewDetails,

    //!TOTAL AMOUNTS
    total_Programming, number_format,

    //*CONFIGURATIONS CHARTS
    sum_branches,

    //!CONFIGURATION PROGRAMING
    options1, ChartProgrammingAmount,

    //!CONFIGURATION RECOLECTED
    total_Recollected, sum_branches_recolected,

    //!CONFIGURATION GLOBAL
    options, series, classifications,

    //*EVENT EXCLUDED PATIENT 
    handleGeneralPatients, valid_loading_patient, patient_excluded,

    //*REPORTS
    exportToExcel,

    //*CONFIGURATIONS FILTER
    handleView, state_filter, loadinfProgramming, handleClosedInformations,
    handleChangeTypePerson, type_filter_person, patient_Include, patient_Excluded, total_patient,

    //*FILTER TABLE 
    filterCon, setFilterCon, filterSin, setFilterSin, totalP,

    //*CONFIGURATION PERIOD
    handleViewMonth, viewMonth, handleViewRange, viewRange, handleClosedViewRange, handleClosedViewMonth, handleViewDetailsFilter, typePeriod, chartPeriod,
    navigateDetailPatient, modalviewCalender, toggleCalender, handleCalender,
    setActiveIndex, activeIndex, branches_programming, sumre,

    // * DEPOSITS
    loadingFinance, detailBranch, depositSerie, depositOptions, loadingDeposits, listMovementsInvoice,
    listDetailBranch, totalGlobal, totalCollected, totalDepositSend, indicatorAmountInvoice,
    totalComplement, indicatorPatient, listMovements,


    start_date, end_date, handleActions, totalRecovered, filtereportPaymentsComplement,

    // ? CONFIGURATION
    modalviewPayment, togglePayment, handlePayment, setSelectedRows, buildSelectedValues, selectedRows,
    modalviewb, toggleb, handlePreviewB, selectedValues,

    CreateMoveFlow, loadingA







  } = useViewCalender();



  // * STYLES DATA TABLE
  const headerStyle = {
    backgroundColor: "#1d5b83",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "11px",
    borderRight: "1px solid #fff",
    borderBottom: "2px solid #fff",
  };

  const cellStyle = {
    fontSize: "11px",
    padding: "5px",
    textAlign: "center",
    fontFamily: "Montserrat, sans-serif",

  };

  const centerStyle = {
    ...cellStyle,
    textAlign: "center",
    zIndex: 2
  };

  const _total = selectedValues.reduce(
    (acc, item) => acc + Number(item.amount),
    0
  );





  // ? CONGIGURATION FOTER

  const totalRow2 = (
    <tr style={{ backgroundColor: 'rgb(1 12 18)', height: '20px' }} className='sticky-footer' >
      <td></td>
      <td className='labeltheadInvoice'>Programado:</td>
      <td className='labeltheadInvoice'>${number_format(total_Programming, 2)}</td>
      <td className='labeltheadInvoice'>Recaudado:</td>
      <td className='labeltheadInvoice'>${number_format(total_Recollected, 2)}</td>
    </tr>
  );


  const [expandedRow, setExpandedRow] = useState(null);

  const handleExpandRow = (index) => {
    if (expandedRow === index) {
      setExpandedRow(null);
    } else {
      setExpandedRow(index);
    }
  };


  const history = useHistory();
  const [key, setKey] = useState(0);
  const modalFullRef = useRef(null);


  const { close, modalProps, open } = useModal({
    onClose: () => {
      setKey((key) => key + 1);
      history.push(`../dashboard/default`);

    },
    background: "#fff",
  });

  const handleReport = (receptor) => {
    open(modalFullRef);
  };

  useEffect(() => {
    handleReport();
  }, []);

  const [totalAmount, setTotalAmount] = useState(0);



  useEffect(() => {

    let sum = 0;

    if (listMovements !== null) {
      listMovements.forEach(element => {
        if (element?.id_pay_method === 29 || element.id_pay_method === 31 || element.id_pay_method === 7) {
          return;
        }

        sum += element.amount;
      });

      setTotalAmount(sum);
    }
  }, [listMovements])


  // ? MENU
  const items =
    [
      { label: 'Programación de flujo', icon: 'pi pi-bell' },
      { label: 'Información global', icon: 'pi pi-folder-open' },

      (!loadingDeposits)
        ? { label: 'Deposito bancario', icon: 'pi pi-chart-line' }
        : null,
    ].filter(Boolean);


  // ? CONFIGURATION TOTAL AMOUNT SERVICE THE AMOUNT 
  const leftContents = (
    <div className="step-texts">
      <label className='f-w-600' style={{ color: "#002940", fontSize: "16px" }}>Ingreso Total De Flujo </label>
      <b style={{ color: "#002940", fontSize: "14px" }}>${number_format(totalAmount, 2)}</b>
    </div>
  );

  const leftContents1 = (
    <div className="step-texts">
      <label className='f-w-600' style={{ color: "#002940", fontSize: "16px" }}>Ingreso Total De Flujo </label>
      <b style={{ color: "#002940", fontSize: "14px" }}>${number_format(totalAmount - totalCollected, 2)}</b>
    </div>
  );

  const leftContents2 = (
    <div className="step-texts">
      <label className='f-w-600' style={{ color: "#002940", fontSize: "16px" }}>Efectivo recuperado </label>
      <b style={{ color: "#002940", fontSize: "14px" }}>${number_format(totalCollected, 2)}</b>
    </div>
  );

  const leftContents3 = (
    <div className="step-texts">
      <label className='f-w-600' style={{ color: "#002940", fontSize: "16px" }}>Total Facturado </label>
      <b style={{ color: "#002940", fontSize: "14px" }}>${number_format(indicatorAmountInvoice, 2)}</b>
    </div>
  );


  // ? CONFIGURATION TAG
  const tagInfo = (rowData) => {
    if (rowData.uuid === null) {
      return <Tag style={{ backgroundColor: "#f8d62b", width: "82px", fontSize: "10px", }} className="mr-2" value={rowData.folio}  ></Tag>;
    }
    return <Tag className="mr-2 " style={{ width: "82px", fontSize: "10px", }} severity='secondary' value={rowData.folio}   ></Tag>;
  };

  // ? CONFIGURATION TAG INVOICE
  const tagInfoInvoice = (rowData) => {
    if (rowData.uuid === null) {
      return <Tag style={{ backgroundColor: "#f8d62b", width: "82px", fontSize: "10px", }} className="mr-2" value={rowData.folio}  ></Tag>;
    }
    return <Tag className="mr-2 " style={{ width: "82px", fontSize: "10px", }} severity='secondary' value={rowData.folio}   ></Tag>;
  };

  // ? CONFIGURATION AMOUNT COMPLEMENT
  const SumTotal = filtereportPaymentsComplement.reduce((acc, r) => acc + (r.payment_amount ?? 0), 0);

  const footerStyle =
  {
    backgroundColor: '#000',
    color: '#fff',
    fontWeight: 'bold',
    textAlign: 'center',
    fontSize: '0.75rem',
    padding: '4px',
  };




  return (
    <Fragment>
      <Container fluid={true}>
        {
          // * HEADER FILTER CALENDER
        }
        <Col xs="12" className='p-l-0 p-r-0'  >
          <Col ref={modalFullRef} style={{ textAlign: "center" }} xs="12" md="12" xl="3" className="cursor-pointer pointer" onClick={() => handleReport()}   >
            <div ref={modalFullRef} onClick={() => handleReport()}  >.</div>
          </Col>
        </Col>
      </Container>
      <ModalEvent
        {
        ...{
          loadingPreview, modalTitle, toggleModalEvent, modalPreviewInvoice,
          start, end, setEnd, setStart, countSelected,
          //*save
          amount_required, handleInputChange, loadingSave, saveProgrammingDiary, handleClose,
          title, observation, validationsCreate,
          loadingViews,
          listBranchesTree, treeViewRef, onRenderItem, tolerance, handleChangeAmount,
          onChangeItemtree, loadingProgramming
        }
        }
      />

      <Modal
        ref={modalFullRef}
        {...modalProps}
        padding={false}
      >
        <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
          <Col sm="12" style={{ marginTop: "2px" }}>
            <TabMenu
              model={items}
              activeIndex={activeIndex}
              onTabChange={(e) => {
                if (e.index !== 1) {
                  setActiveIndex(e.index);
                } else {
                  setActiveIndex(0);
                }
              }}
              className="custom-tabmenu full-width custom-tabmenu-orange"
              style={{ marginBottom: "15px" }}
            />
            {activeIndex === 0 && (
              <Programming
                {
                ...{
                  loadinfProgramming, detailInformation, hoveredColumn, handleExpandRow, setHoveredColumn,
                  totalRow2, number_format, handleViewDetailsFilter, handleViewDetails, expandedRow,
                  handeGeneralEvent, handleViewMonth, handleViewRange,
                  viewMonth, dateFilter, setDateFilter, handleFilterDate, handleClosedViewMonth,
                  viewRange, state_filter, setStart, setEnd, handleView, handleClosedViewRange, start, end,
                  handleCalender

                }
                }
              />
            )}
            {(activeIndex === 1 && valid_visible === true) && (
              <DetailProgramming
                {
                ...{
                  typePeriod, ChartProgrammingAmount, sum_branches, options1, number_format, sum_branches_recolected,
                  options, series, listBranchesTree, handleGeneralPatients, classifications,
                  valid_loading_patient, patient_excluded, handleClosedInformations, handleChangeTypePerson, type_filter_person,
                  patient_Include, patient_Excluded, total_patient,
                  filterCon, setFilterCon,
                  filterSin, setFilterSin, totalP, exportToExcel, navigateDetailPatient, branches_programming, sumre,
                  chartPeriod, setSelectedRows, buildSelectedValues, selectedRows,
                  modalviewb, toggleb, handlePreviewB, CreateMoveFlow


                }
                }
              />
            )}
            {
              (loadingDeposits) ? "" :
                activeIndex === 2 && (
                  <ProgrammingDeposits
                    {
                    ...{
                      loadingFinance, detailBranch, depositSerie, depositOptions, listMovements, listMovementsInvoice, number_format,
                      totalGlobal, leftContents, leftContents1, leftContents2, leftContents3, listDetailBranch, indicatorPatient,
                      totalComplement, totalDepositSend, totalAmount, start_date, end_date, handleActions, handleInputChange,
                      totalRecovered, totalCollected, filtereportPaymentsComplement, handlePayment,
                      loadingDeposits,

                    }
                    }
                  />
                )
            }
          </Col>
        </div>
      </Modal>
      {
        // * DIALOG PAYMENT
      }

      <Dialog
        header="Ingresos de otros meses"
        visible={modalviewPayment}
        modal
        dismissableMask
        onHide={togglePayment}
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >
        <Col sm="12" className='pb-3 pt-4 p-l-0 p-r-0'>
          <DataTable
            value={filtereportPaymentsComplement}
            dataKey="idBranch"
            paginator
            rows={10}
            rowsPerPageOptions={[10, 50, 100, 200]}
            responsiveLayout="scroll"
            emptyMessage={
              <div className="text-center">
                <img
                  src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")}
                  style={{ width: "45%" }}
                  alt="Sin resultados"
                />
                <br />
                <p className="badge badge-light-primary mt-2" style={{ fontSize: "10px" }}>
                  No hay ingresos de otros meses.
                </p>
              </div>
            }
          >
            <Column header="#" sortable body={(row, { rowIndex }) => rowIndex + 1} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="payment_date" sortable header="Fecha" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column header="Folio" body={(row) => tagInfo(row)} headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column field="nameBussines" sortable header="Receptor" headerStyle={headerStyle} style={centerStyle} footer="Totales:" footerStyle={footerStyle} />
            <Column field="payment_amount" sortable header="Monto" headerStyle={headerStyle} style={centerStyle} footer={`$${number_format(SumTotal, 2)}`} footerStyle={footerStyle} />
            <Column field="uuid" sortable header="UUID" headerStyle={headerStyle} style={centerStyle} footer="" />
            <Column header="F. de pago" body={(row) => tagInfoInvoice(row)} headerStyle={headerStyle} style={centerStyle} footer="" />
          </DataTable>
        </Col>

      </Dialog>
      {
        // * DIALOG PROGRAMING CALENDER
      }

      <Dialog
        header="Visualizar programación"
        visible={modalviewCalender}
        modal
        dismissableMask
        onHide={toggleCalender}
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >
        <Col sm="12" className='pt-3 ' >
          <Col sm="12" className='p-l-0 p-r-0 p-t-3 pb-3 shadow-sm' style={{
            backgroundColor: 'white', border: '1px solid #e0e0e0',
            borderRadius: '10px', padding: '12px', fontSize: '12px'
          }} >
            <div
              style={{
                color: "#856404",
                fontSize: "0.78rem",
                marginTop: "6px",
                fontWeight: "500",
                backgroundColor: "#fff3cd",
                padding: "4px 10px",
                borderRadius: "6px",
                boxShadow: "0 1px 2px rgba(0,0,0,0.08)",
                display: "flex",
                alignItems: "center",
                gap: "6px",
                border: "1px solid #ffeeba",
              }}

            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#d39e00" }}></i>
              Para editar un dia es necesario seleccionar el evento.
            </div> <br />
            <FullCalendar
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              initialView="dayGridMonth"
              nowIndicator={true}
              headerToolbar={{
                left: "prev,today,next",
                center: 'title',
                right: 'dayGridMonth,timeGridWeek,timeGridDay'
              }}
              locale={esLocale}
              ref={calendarRef}
              timeZone={'UTC'}
              editable={true}
              selectable={true}
              selectMirror={true}
              dayMaxEvents={true}
              weekends={weekendsVisible}
              datesSet={(info) => {
                const startStr = "";
                const endStr = "";
                GetProgrammingAmount({ startStr, endStr });
              }}
              events={eventView}
              select={handleEvent}
              eventClick={ViewsEvents}
              dateClick={handleSelectDate}
            />


          </Col>

        </Col>

      </Dialog>

      {
        // * FLUJO B A FLUJO A
      }

      <Dialog
        header="Moviento de tipo de flujo"
        visible={modalviewb}
        modal

        onHide={toggleb}
        headerStyle={{
          backgroundColor: '#0d3b59',
          color: 'white',
          fontWeight: 'bold',
        }}
        footer={
          <>
            <Button
              disabled={loadingA}
              size="sm"
              color="danger"
              type="button"
              onClick={toggleb}
            >
              regresar
            </Button>

            <Button
              disabled={loadingA}
              size="sm"
              type="button"
              color="secondary"
              className="btn-air-light"
              onClick={() => CreateMoveFlow(selectedValues)}
            >
              Aceptar
            </Button>
          </>
        }
        pt={{
          header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
          headerIcon: { style: { color: 'white' } },
          content: { style: { paddingLeft: "1px" } }
        }}
      >
        <Col sm="12" className="pt-3">
          <Col
            sm="12"
            className="shadow-sm"
            style={{
              backgroundColor: "#fff",
              border: "1px solid #e5e7eb",
              borderRadius: "12px",
              padding: "16px",
              fontSize: "12px"
            }}
          >

            <div
              style={{
                background: "#fff3cd",
                color: "#856404",
                borderRadius: "8px",
                padding: "8px 12px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontSize: "0.8rem",
                marginBottom: "18px"
              }}
            >
              <i className="fa fa-exclamation-triangle" style={{ color: "#f59e0b" }} />
              <span>
                Todos estos pacientes serán movidos del <b>flujo B</b> al <b>flujo A</b>.
              </span>
            </div>

            <Row>
              {selectedValues.map((item, index) => (
                <Col md="4" sm="6" xs="12" key={item.idWorkOrder}>
                  <div
                    className="hover-shadow"
                    style={{
                      background: "#fafafa",
                      borderRadius: "10px",
                      padding: "12px",
                      marginBottom: "12px",
                      border: "1px solid #eee",
                      transition: "all 0.2s ease"
                    }}
                  >
                    <div style={{ fontSize: "0.85rem", fontWeight: 600 }}>
                      {index + 1}. {item.patient}
                    </div>

                    <div
                      style={{
                        fontSize: "0.75rem",
                        color: "#6b7280",
                        marginTop: "4px"
                      }}
                    >
                      NIM:{" "}
                      <b style={{ color: "#f59e0b", fontWeight: 600 }}>
                        {item.nim}
                      </b>
                    </div>

                    <div
                      style={{
                        marginTop: "10px",
                        fontWeight: 700,
                        color: "#16a34a",
                        fontSize: "1rem",
                        textAlign: "right"
                      }}
                    >
                      ${item.amount.toLocaleString()}
                    </div>
                  </div>
                </Col>
              ))}
            </Row>

            <div className="text-right mt-3">
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "8px",
                  background: "#16a34a",
                  color: "#fff",
                  padding: "8px 16px",
                  borderRadius: "999px",
                  fontWeight: 600,
                  fontSize: "0.85rem"
                }}
              >
                <i className="fa fa-dollar-sign" />
                Total:{" "}
                {`$${selectedValues
                  .reduce((acc, item) => acc + Number(item.amount), 0)
                  .toLocaleString()}`}
              </div>
            </div>

          </Col>
        </Col>


      </Dialog>


    </Fragment>
  )
}
